<template>
    <div class="ht-tab-wrap">
      <div class="section-title-wrapper text-center section-space--mb_30">
        <h5 class="section-title font-width-light wow move-up">Orthèses Plantaires</h5>
      </div>
      <div class="row">
<!--        <div class="col-md-4">-->
<!--          <img class="img-fluid" src="@/assets/img/pied-pro/services/ongle-incarne1.jpg" alt="product-details" />-->
<!--        </div>-->
        <div class="col-md-12 ortheses-plantaire-tab-text" style="color: #05052d;">
          <div class="float-left" style="width: 330px; margin-right: 20px;">
            <img class="img-fluid" src="@/assets/img/pied-pro/services/orthese-plantaire.png" alt="=Orthèses Plantaires" />
          </div>

          QU’EST-CE QUE C’EST?
          L’orthèse plantaire est un traitement qui permet de soulager des pathologies spécifiques aux pieds
          diagnostiquées par votre médecin ou votre podiatre. L’orthèse est aussi un moyen de prévention de certaines
          conditions.
          <br><br>
          L’orthèse permet d’améliorer la biomécanique des pieds et ne peut être prescrite que par un podiatre ou un
          médecin, après une évaluation de votre condition et l’élaboration d’un diagnostic précis.
          <br><br>
          Les orthèses plantaires prescrites par le podiatre sont fabriquées à partir d’empreintes sur mesure et ne
          doivent pas être confondues avec les modèles préfabriqués qu’on trouve dans certains commerces de détail.
          <br><br>
          Avant de prescrire une orthèse, le podiatre procède à un examen biomécanique et postural. Si nécessaire,
          des radiographies sont également prises afin de compléter l’examen. Le podiatre tient également compte de
          l’ensemble de votre histoire médicale afin de déterminer si votre problème est bien lié à vos pieds et non
          à un autre problème de santé qui pourrait nécessiter une consultation chez votre médecin. Ces éléments ne
          sont pas considérés dans un commerce de détails qui fait la vente d’orthèses.
          <br><br>
          <div class="float-right" style="width: 300px; margin-left: 15px;">
            <img class="img-fluid" src="@/assets/img/pied-pro/services/orthese-fabrication.jpg" alt="=Orthèses Plantaires" />
          </div>
          Toute fabrication ou modification d’une orthèse effectuée dans un laboratoire doit être faite à la suite
          d’une ordonnance signée par un podiatre ou un médecin, seuls professionnels autorisés par la loi et par
          le Code des professions à donner cette ordonnance.
          <br><br>
          Les professionnels autorisés par la loi à exécuter une ordonnance pour une orthèse plantaire sont les
          techniciens en orthopédie et membres de l’Ordre des technologues professionnels. Par ailleurs, la Loi sur
          la podiatrie autorise aussi le podiatre à fabriquer, à transformer, à modifier ou à vendre une orthèse
          plantaire à son patient.
          <br><br>
          DIFFÉRENTS TYPES ET COMPOSANTES D’ORTHÈSES
          <br><br>
          Il existe différents types d’orthèse, dont :
          <br><br>
          l’orthèse fonctionnelle, qui corrige la biomécanique des pieds;
          <br>
          l’orthèse de confort, dont la fonction primaire est de procurer un certain coussin et un léger soutien aux pieds.
          <br><br>
          Dans la majorité des cas, il n’est pas nécessaire de se procurer des chaussures faites sur mesure pour porter l’orthèse plantaire.
          <br><br>
          L’ORTHÈSE CHEZ L’ENFANT
          <br><br>
          Si votre enfant chute souvent, use toujours ses souliers au même endroit, se fatigue rapidement lorsqu’il
          marche, ressent des douleurs aux pieds, aux jambes, aux genoux ou a tendance à marcher sur la pointe des
          pieds, une évaluation posturale et biomécanique par un podiatre est nécessaire.
          <br><br>
          En lui faisant consulter un podiatre dès son jeune âge, vous pouvez éviter à votre enfant des problèmes
          futurs à ses pieds.
          <br><br>
          QUELS PROBLÈMES LES ORTHÈSES PEUVENT-ELLES TRAITER?
          <br><br>
          Le port d’orthèse peut permettre de :
          <br>
          corriger la position des pieds plats et des pieds creux;
          <br>
          réduire la progression de certaines déformations, dont l’hallux abducto-valgus (oignon);
          <br>
          diminuer les douleurs causées par certaines pathologies (fasciite plantaire, tendinite, douleurs aux genoux,
          au dos, etc.), lorsque ces dernières sont secondaires à une biomécanique défaillante des pieds;
          <br>
          diminuer les symptômes liés à l’arthrose aux pieds;
          <br>
          prévenir les complications reliées au pied diabétique.
          <br><br>
          RECOMMANDATIONS CONCERNANT LE PORT D’ORTHÈSES
          <br><br>
          Avant de vous procurer des orthèses, assurez-vous qu’on fasse des examens de votre biomécanique et de
          votre posture, une analyse de votre démarche et des empreintes de vos pieds.
          <br><br>
          Bien qu’il soit normal de ressentir certains inconforts au départ, soyez attentif aux signes positifs et
          négatifs de l’adaptation.
          <br><br>
          Des modifications sur les orthèses peuvent être nécessaires pour améliorer votre confort et votre posture.
          <br><br>
          Si vous portez des orthèses pour la première fois, mettez-les de façon graduelle.
          <br><br>
          Portez des chaussures adaptées aux orthèses. Certains souliers, comme des mules ou des sandales, peuvent diminuer les effets thérapeutiques des orthèses.
          <br><br>
          Source : Ordre des Podiatres du Québec
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'OrthesesPlantaires',
    };
</script>